
import { motion } from 'framer-motion';

const WhatsAppWidget = () => {
  return (
    <>
      {/* WhatsApp Button */}
      <motion.a
        href="https://wa.me/905071344668?text=Merhaba,%20ben%20sizinle%20bursasulamasistemleri.com%20sitesinden%20iletişime%20geçiyorum."
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 z-50 w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-2xl cursor-pointer"
        whileHover={{ scale: 1.1, y: -4 }}
        whileTap={{ scale: 0.95 }}
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.3, delay: 1 }}
        aria-label="WhatsApp ile iletişime geç"
      >
        <i className="ri-whatsapp-fill text-white text-3xl"></i>
      </motion.a>

      {/* Phone Call Button */}
      <motion.a
        href="tel:+905071344668"
        className="fixed bottom-28 right-8 z-50 w-16 h-16 bg-[#14B8A6] rounded-full flex items-center justify-center shadow-2xl cursor-pointer"
        whileHover={{ scale: 1.1, y: -4 }}
        whileTap={{ scale: 0.95 }}
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.3, delay: 1.2 }}
        aria-label="Telefon ile ara"
      >
        <i className="ri-phone-fill text-white text-3xl"></i>
      </motion.a>
    </>
  );
};

export default WhatsAppWidget;
